import React from 'react';

function Err404() {
  return (
    <div>
      <p>404 Not Found</p>
    </div>
  );
}

export default Err404;
